// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1RBjj","label":"SetPasswdForm_label__2v4Xr"};